import { ReactNode } from 'react';

import { Alert, Modal, Stack } from '@mantine/core';

type SubscribeModalContentsProps = {
    title: string;
    children: ReactNode;
    description?: ReactNode;
};

export const SubscribeModalContentContainer = ({ title, children, description }: SubscribeModalContentsProps) => {
    return (
        <>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
                <Modal.CloseButton />
            </Modal.Header>
            <Modal.Body>
                <Stack gap="lg">
                    {description && <Alert color="primary">{description}</Alert>}

                    {children}
                </Stack>
            </Modal.Body>
        </>
    );
};
